import Vue from 'vue'
import App from './App.vue'
import Router from "vue-router";
// import routes from "./routers";
import router from "./routers";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import md5 from 'js-md5'
Vue.prototype.$md5 = md5

Vue.config.productionTip = false
Vue.use(Router);
Vue.use(ElementUI);
// const router = new Router({
//   routes,
//   mode: "hash",
// });
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0); // 滚动到顶部
  next();
});
// new Vue({
//   el: "#app",
//   router,
//   store,
//   components: { App },
//   template: "<App/>"
// });
new Vue({
  router,
  render: h => h(App),
})
  .$mount('#app')
